<template>
    <v-container fill-height class="align-start">
        <div class="mx-auto col-12 px-0 px-lg-3">
            <v-card
                height="85vh"
                flat
                style="overflow: hidden;"
            >
                <!-- CARD HEADERS -->
                <v-row no-gutters class="align-center">
                    <v-col sm="12" lg="4" class="pa-2" :class="{'d-none d-lg-block': !!selectedEmail.id}">
                    <!-- MESSAGES HEADER & SEARCH -->
                        <v-card-title class="ml-auto py-2">
                            <h4 class="font-weight-bold pl-1">
                                {{ showContacts ? 'Contacts' : 'Messages' }}
                            </h4>
                        </v-card-title>

                        <div class="d-flex justify-space-between" v-if="!showContacts">
                            <v-btn
                                color="primary"
                                dark
                                text
                                @click="fetchMessages(true, searchWord)"
                            > ok </v-btn>
                            <v-btn
                                class="ml-lg-n16"
                                color="primary"
                                dark
                                text
                                @click="readAll"
                            > Read all </v-btn>

                            <v-btn
                                color="primary"
                                dark
                                text
                                @click="showAllContacts"
                            > View Contacts </v-btn>
                        </div>

                        <div class="float-right" v-else>
                            <v-btn
                                color="primary"
                                dark
                                text
                                @click="showMessages"
                            > View Messages </v-btn>
                        </div>
                    </v-col>
                    <v-divider
                        vertical
                        light
                        v-if="$vuetify.breakpoint.mdAndUp"
                        class="flex-shrink-1"
                        width="1px"
                        color="#DFDBE5"
                    />
                    <!-- SELECTED EMAIL MASTHEAD -->
                    <messages-selected-email-masthead
                        v-if="selectedEmail.id && !showThread"
                        :selected-email.sync="selectedEmail"
                        :selected-message.sync="selectedMessage"
                    />
                    <messages-selected-thread-masthead
                        @close="closeThread"
                        v-else-if="selectedEmail.id && showThread"
                        :selected-thread.sync='threadEmail'
                    />
                    <v-col
                        v-else
                        class="pa-2 text-center no-selection"
                        style="background: white"
                    >
                        <div class="d-block d-lg-flex justify-space-right">
                            <p class="mb-0 font-weight-bold pl-3 mr-1">Your Kaoshi Email: </p>
                            <p class="mb-0" style="color: #181235;">{{ userKaoshiEmail }}</p>
                            <v-spacer></v-spacer>
                        </div>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp">
                    <v-divider
                        light
                        class="flex-grow-1"
                        width="1px"
                        color="#f5f5f5"
                    />
                </v-row>
                <v-row
                    class="mt-0"
                    no-gutters
                    height="100%"
                >
                    <v-col sm="12" lg="4" :class="{'d-none d-lg-block': !!selectedEmail.id}">
                        <v-text-field
                            v-model="searchWord"
                            class="pa-3 ml-auto"
                            label="Search ..."
                            color="primary"
                            prepend-inner-icon="mdi-magnify"
                            solo
                            flat
                            hide-details
                            v-if="!showContacts"
                            dense
                            @keyup.enter="fetchMessages(true, searchWord)"
                        />

                        <v-text-field
                            v-model="searchWord"
                            class="pa-3 ml-auto"
                            label="Search ..."
                            color="primary"
                            prepend-inner-icon="mdi-magnify"
                            solo
                            flat
                            hide-details
                            v-else
                            dense
                        />
                        <!-- EMAIL LIST -->
                        <messagesList
                            :emails-chain="emailsChain"
                            :search="searchWord"
                            :onSearch="onSearch"
                            @select-email="selectEmail"
                            v-if="!showContacts"
                        >
                            <div class="text-center pa-5">
                                <v-progress-circular
                                    v-if="loading"
                                    indeterminate
                                    color="primary"
                                    class="ml-2"
                                />
                                <v-btn
                                    v-if="hasNextPage"
                                    class="ml-1"
                                    color="primary"
                                    dark
                                    @click="fetchMessages(false)"
                                > {{ loading ? 'Loading...' : 'Load more' }} </v-btn>
                            </div>
                        </messagesList>

                        <contactsList
                            v-if="showContacts"
                            :contacts="filteredContacts"
                            :search="searchWord"
                            :onSearch="onSearch"
                            @select-contact="selectContact"
                        >
                            <div class="text-center pa-5">
                                <v-progress-circular
                                    v-if="loading"
                                    indeterminate
                                    color="primary"
                                    class="ml-2"
                                />

                                <v-btn
                                    v-if="hasNextPage"
                                    class="ml-1"
                                    color="primary"
                                    dark
                                    @click="fetchMessages(false)"
                                > {{ loading ? 'Loading...' : 'Load more' }} </v-btn>
                            </div>
                        </contactsList>
                    </v-col>
                    <v-divider
                        vertical
                        v-if="$vuetify.breakpoint.mdAndUp"
                        light
                        class="flex-shrink-1"
                        width="1px"
                        color="#f5f5f5"
                    />
                    <v-col class="d-lg-flex flex-column" :class="`${ selectedEmail.id || threadEmail.id ? 'd-flex' : 'd-none' }`">
                        <!-- SELECTED EMAIL CHAIN -->
                        <messages-chain
                            :selectedMessage.sync="selectedMessage"
                            :search="searchWord"
                            :on-search="onSearch"
                            :selected-email-chain="selectedEmailChain"
                            :selected-email="selectedEmail"
                            :selected="!!selectedEmail.id"
                            v-if="!showThread"
                            :user-kaoshi-email="userKaoshiEmail"
                            @show-thread="openThread"
                            :contacts="contacts"
                        />
                        <messages-thread
                            v-else
                            :search="searchWord"
                            :on-search="onSearch"
                            :thread-email="threadEmail.from_email"
                            :thread-email-count="threadEmail.thread_messages_count || 0"
                            :thread-email-id="threadEmail.id || 0"
                            :thread-emails="messageThreadChilds[threadEmail.id] ? messageThreadChilds[threadEmail.id] : []"
                        />
                        <!-- MESSAGE DRAFTING SECTION -->
                        <!--messages-drafting></messages-drafting-->
                    </v-col>
                </v-row>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import messagesSelectedEmailMasthead from './components/messages-selected-email-masthead.vue';
    import messagesSelectedThreadMasthead from './components/messages-selected-thread-masthead.vue'
    import messagesList from './components/messages-list.vue';
    import contactsList from './components/contacts-list.vue';
    import messagesChain from './components/messages-chain.vue';
    import messagesThread from './components/messages-thread.vue';
    import emailApiFetcher from '../mixins/email-service-api.mixin';
    import contacts from '../modules/contacts';
    export default {
        /**
         * I've added a list of all lifecycle hooks below for my own reference while building the page
         * This is my first time creating a vuejs page from scratch, and I want to have a reference
         * to what my options are. I've kept them in the order provided in the docs.
         */
        components: {
            messagesSelectedEmailMasthead,
            messagesList,
            messagesChain,
            contactsList,
            messagesThread,
            messagesSelectedThreadMasthead,
        },
        mixins: [emailApiFetcher],
        data() {
            return ({
                contacts,
                showThread: false,
                showContacts: false,
                loading: false,
                selected: [],
                selectedEmailChain: [],
                selectedEmail: {
                    brand: {
                        code: 'other',
                    },
                },
                attachments: [],
                emails: [],
                page: 1,
                hasNextPage: false,
                searchWord: '',
                onSearch: false,
                threadEmailChilds: {},
                threadEmail: {},
                messageThreadChilds: {},
                selectedMessage: null,
            });
        },
        mounted() {
            const vm = this;
            vm.fetchUnreadMessagesCount();
            vm.fetchMessages(true);
        },
        methods: {
            closeThread() {
                this.showThread = false;
                this.threadEmail = {}
            },
            openThread(threadEmail) {
                this.threadEmail = threadEmail;
                this.showThread = true;
                if (!Object.keys(this.messageThreadChilds).includes(threadEmail.id.toString())) {
                    this.fetchThreadMessages(threadEmail)
                }
            },
            fetchThreadMessages(threadEmail) {
                const vm = this;
                // fetch emails thread
                Vue.backendApi()
                    .emailAPI({
                        url: '/console/api/v1/messages?limit=20&to_email=qwjkle123qwe333@kaoshinetwork.com&page=1', // `/console/api/v1/messages?parent_thread_id=${threadEmail.id}`,
                        method: 'get',
                    })
                    .then(onSuccess, onError);

                function onSuccess(response) {
                    vm.messageThreadChilds[threadEmail.id] = response.data.results
                    vm.showThread = true;
                    return true;
                }
                function onError(err) {
                    console.log('error: ', err);
                }
            },
            showAllContacts() {
              this.showContacts = true;
              this.selectedEmail = {};
              this.closeThread();
              this.selectedEmailChain = [];
              this.searchWord = '';
            },
            showMessages() {
              this.showContacts = false;
              this.searchWord = '';
              this.closeThread();
              this.selectedEmail = {};
              this.selectedEmailChain = [];
            },
            selectContact(email) {
                const vm = this;
                vm.closeThread();

                if(vm.emailsChain.childs[email.from_email]) {
                    this.selectEmail(email);
                    return;
                }
                Vue.set(vm, 'selectedEmailChain', []);
                Vue.set(vm, 'selectedEmail', email);
            },
            selectEmail(email) {
                const vm = this;
                vm.closeThread();

                vm.selectedMessage = null;

                const selectedEmailChain = vm.emailsChain.childs[email.from_email].messages;
                Vue.set(vm, 'selectedEmailChain', selectedEmailChain);
                Vue.set(vm, 'selectedEmail', email);
                if (!vm.emailsChain.childs[email.from_email]) return
                // unread messages of the chain that aren't read yet
                const selectedEmailChainUnreadMessagesIds = vm.emailsChain.childs[email.from_email].unread_message_ids;
                function onSuccess(response) {
                    // update unread message count
                    vm.$store.commit(
                        'storeUnreadMessagesCount',
                        (vm.$store.state.unreadMessagesCount - selectedEmailChainUnreadMessagesIds.length),
                    );

                    // update messages read status
                    vm.emailsChain.childs[email.from_email].messages.forEach((message) => {
                        Vue.set(vm.emails[message.index], 'is_read', true);
                    });
                    return true;
                }

                function onError(err) {
                    // eslint-disable-next-line no-console
                    console.trace('Error: ', err);
                }

                if (selectedEmailChainUnreadMessagesIds.length !== 0) {
                    Vue.backendApi()
                        .emailAPI({
                            url: '/console/api/v1/message/read-messages',
                            method: 'post',
                            data: {
                                message_ids: selectedEmailChainUnreadMessagesIds,
                            },
                        })
                        .then(onSuccess, onError);
                }
            },
            readAll() {
                const vm = this;
                function onSuccess() {
                    // update unread message count
                    vm.$store.commit('storeUnreadMessagesCount', 0);
                    // update local messages read status
                    Object.keys(vm.emailsChain.childs).forEach(chainEmail => {
                        vm.emailsChain.childs[chainEmail].messages.forEach((message) => {
                            Vue.set(vm.emails[message.index], 'is_read', true);
                        });
                    });
                    return true;
                }

                function onError(err) {
                    // eslint-disable-next-line no-console
                    console.trace('Error: ', err);
                }
                const toEmail = vm.userKaoshiEmail;
                Vue.backendApi()
                    .emailAPI({
                        url: '/console/api/v1/message/read-all-messages',
                        method: 'post',
                        data: {
                            email: toEmail,
                        },
                    })
                    .then(onSuccess, onError);
            },
            selectLatestEmail() {
                const vm = this;
                if (vm.emails && vm.emails.length > 0) {
                    vm.selectEmail(vm.emails[0]);
                }
            },
            fetchMessages(first = null, search = null) {
                const vm = this;
                Vue.set(vm, 'selectedEmailChain', []);
                Vue.set(vm, 'selectedEmail', {
                    brand: {
                        code: 'other',
                    },
                });
                vm.loading = true;
                const toEmail = vm.userKaoshiEmail;
                if (first) {
                    Vue.set(vm, 'emails', []);
                    vm.page = 1;
                }
                vm.next = `/console/api/v1/messages?mailbox__email=${toEmail}&page=${vm.page}`;
                vm.onSearch = false;
                if (search) {
                    vm.onSearch = true;
                    vm.next = `/console/api/v1/messages?mailbox__email=${toEmail}&search=${search}&page=${vm.page}`;
                }

                Vue.backendApi()
                    .emailAPI({
                        url: vm.next,
                        method: 'get',
                    })
                    .then(onSuccess, onError);

                function onSuccess(response) {
                    vm.loading = false;
                    const newEmailsResults = response.data.results;
                    const emails = [...vm.emails, ...newEmailsResults];
                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < emails.length; i++) {
                        emails[i].index = i;
                    }
                    Vue.set(vm, 'emails', emails);
                    vm.page += 1;
                    if (response.data.next) vm.hasNextPage = true;
                    else vm.hasNextPage = false;
                    return true;
                }

                function onError(err) {
                    vm.loading = false;
                    vm.$swal({
                        type: 'error',
                        title: 'We were unable to fetch your email',
                        text: err,
                    });
                }
            },
        },
        computed: {
            filteredContacts() {
                return this.contacts.filter(key =>
                  key.name.toLowerCase().includes(this.searchWord.toLowerCase())
                  || key.email.toLowerCase().includes(this.searchWord.toLowerCase()))
            },
            userEmail() {
                return this.$store.state.user.email;
            },
            userKaoshiEmail() {
                return this.$store.state.user.kaoshi_email;
            },
            emailNotification() {
                return this.$store.state.emailNotification;
            },
            /**
             * return emails with threads messages.
             * The list of email looks like
             * chain: {
             *     from_emails: ['sender_1@kaoshinetwork.com', 'sender_2@kaoshinetwork.com', ...]
             *     childs: {
             *          'sender_1@kaoshinetwork.com': {
             *              messages: [{message_object1}, {message_object2}, ...],
                            unreadMessageCount: 0,
                            unread_message_ids: [],
             *          }
             *     }
             * }
             */
            emailsChain() {
                const vm = this;
                const chain = {
                    messages: [],
                    childs: {},
                    from_emails: [],
                };
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < vm.emails.length; i++) {
                    const message = vm.emails[i];
                    if (chain.from_emails.includes(message.from_email)) {
                        chain.childs[message.from_email].messages.push(message);
                    } else {
                        chain.messages.push(message);
                        chain.childs[message.from_email] = {
                            messages: [],
                            unreadMessageCount: 0,
                            unread_message_ids: [],
                        };
                        chain.childs[message.from_email].messages.push(message);
                        chain.from_emails.push(message.from_email);
                    }
                    if (!message.is_read) {
                        chain.childs[message.from_email].unreadMessageCount += 1;
                        chain.childs[message.from_email].unread_message_ids.push(message.id);
                    }
                }
                return chain;
            },
        },

        // DOM //
        // el,
        // template,
        // replace,
        //////////////////////

        // Lifecycle //
        // created
        watch: {
            emailNotification(notification) {
                const vm = this;
                // fetch email corresponding to notification
                Vue.backendApi()
                    .emailAPI({
                        url: `/console/api/v1/messages?id=${notification.message_id}`,
                        method: 'get',
                    })
                    .then(onSuccess, onError);
                function onSuccess(response) {
                    const emails = [
                      ...vm.emails,
                    ];
                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < response.data.results.length; i++) {
                        const message = response.data.results[i];
                        if (message.parent_thread_id) {
                            vm.threadEmailChilds[parent_thread_id].push(message);
                        } else {
                            emails.push(message);
                            // eslint-disable-next-line no-plusplus
                            for (let i = 0; i < emails.length; i++) {
                                emails[i].index = i;
                            }
                            Vue.set(vm, 'emails', emails);
                        }
                    }
                    return true;
                }
                function onError(err) {
                    console.log('error: ', err);
                }
            },
        },
        // beforeCompile,
        // compiled,
        // ready,
        // attached,
        // detached,
        // beforeDestroy,
        // destroyed,
        //////////////////////

        // Assets //
        // directives,
        // elementDirectives,
        // filters,
        // components,
        // transitions,
        // partials,
        //////////////////////

        // Others //
        // inherit,
        // events,
        // watch,
        // mixins,
        name: 'user-messages',
        //////////////////////
    };
</script>

<style>

.theme--light.v-divider {
    border-color: rgba(0,0,0,0.02);
}

.theme--light.v-text-field--solo-flat>.v-input__control>.v-input__slot {
    background: #f8f8fd !important;
}

.no-selection {
    background-color: #DFDBE5;
    background-repeat: repeat;
    background-image: url('/images/chat-bg.jpg');
}

</style>
